export default __webpack_public_path__ + "static/media/women-enterpreneurs.6d953179.svg";